// extracted by mini-css-extract-plugin
module.exports = {"tax-price":"wm4EHSsyHF30sXe-5XGMc","tax-padding-left":"_2ZKrVhN-0To-n0eS7LkTAm"};